module.exports = __webpack_public_path__ + "img/pro_mega10_04.b8f9b702.png";